class EventBus {
    constructor() {
        this.listeners = {};
    }

    // Register an event listener
    on(componentId, event, callback) {
        if (!this.listeners[event]) {
            this.listeners[event] = {};
        }

        console.log('on', event, componentId);
        this.listeners[event][componentId] = callback;
    }

    // Deregister an event listener
    off(componentId, event) {
        if (!this.listeners[event]) return;
        if (!this.listeners[event][componentId]) return;
        delete this.listeners[event][componentId];
    }

    // Trigger an event
    emit(event, data) {
        if (!this.listeners[event]) return;
        console.log('emit', event, data);
        Object.values(this.listeners[event]).forEach(callback => callback(data));
    }
}

// Create a singleton instance of EventBus
const eventBus = new EventBus();
export default eventBus; 